module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "min-height": "150px"
    }
  }, [(_vm.isLoading) ? _c('loader') : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', [_c('h5', [_vm._v("Recording History")]), _vm._v(" "), _c('v-client-table', {
    attrs: {
      "data": _vm.culturalResourceRecordings,
      "columns": _vm.crrGridSpec.columns,
      "options": _vm.crrGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "view",
      fn: function(props) {
        return [(props.row.recordingTypeId !== _vm.recordingTypeList.Normalization) ? _c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('router-link', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "font-size": "18px"
          },
          attrs: {
            "to": {
              path: '/CulturalResourceRecording/' + props.row.culturalResourceRecordingId
            },
            "tag": "a"
          }
        })], 1) : _vm._e()]
      }
    }, {
      key: "shpoCrRecordingNotes",
      fn: function(props) {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(props.row.shpoCrRecordingNotes)
          }
        })]
      }
    }, {
      key: "reportGen",
      fn: function(props) {
        return [_c('button', {
          staticClass: "btn btn-primary",
          attrs: {
            "disabled": _vm.reportLoading,
            "name": "siteFormReport"
          },
          on: {
            "click": function($event) {
              _vm.genSiteFormReport(props.row.culturalResourceRecordingId)
            }
          }
        }, [_vm._v("Generate")])]
      }
    }])
  }), _vm._v(" "), _c('h5', [_vm._v("Scanned Site Form")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.scannedSiteFormList), function(form) {
    return _c('tr', {
      key: form.mediaId
    }, [_c('td', [_c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('a', {
      staticClass: "fa fa-cloud-download",
      staticStyle: {
        "font-size": "18px"
      },
      attrs: {
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          _vm.downloadForm(form)
        }
      }
    })])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(form.filename))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(form.comment))])])
  }), _vm._v(" "), (_vm.scannedSiteFormList.length === 0) ? _c('tr', [_c('td', {
    staticStyle: {
      "background-color": "#edf0f2",
      "text-align": "center"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n                            No matching records\n                        ")])]) : _vm._e()], 2)])], 1) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Download")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("File Name")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("Comment")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15fdacda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CulturalResourceRecordingHistory.vue
// module id = 900
// module chunks = 1